export default "__VITE_ASSET__DJP9ezcd__"